import { loadingBarReducer } from "react-redux-loading-bar";
import { combineReducers } from "redux";

export const reducers = combineReducers({
  loadingBar: loadingBarReducer,
});
